<div>
  <app-mat-spinner-overlay *ngIf="showSpinner"> </app-mat-spinner-overlay>

  <form #df="ngForm"
        novalidate
        (keydown.enter)="searchQuickloanCustomerInquiry()"
        class="formborder">
    <div class="row m-0 col-md-12">
      <div class="col-md-2">
        <span class="required-lable">From Date</span>
        <div class="datepicker_feild">
          <input [matDatepicker]="picker"
                 dateConvert
                 placeholder="DD/MM/YYYY"
                 name="DateFrom"
                 [(ngModel)]="DateFrom"
                 id="DateFrom"
                 class="form-control input-text-css"
                 required
                 #refDateFrom="ngModel"
                 [ngClass]="{
              'is-invalid': df.submitted && refDateFrom.invalid,
              'alert-warning':
                refDateFrom.invalid &&
                (refDateFrom.dirty ||
                  refDateFrom.touched ||
                  refDateFrom.untouched)
            }" />

          <mat-datepicker-toggle matSuffix
                                 [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </div>
      </div>

      <div class="col-md-2">
        <span class="required-lable">To Date</span>
        <div class="datepicker_feild">
          <input [matDatepicker]="picker2"
                 dateConvert
                 placeholder="DD/MM/YYYY"
                 name="DateTo"
                 [(ngModel)]="DateTo"
                 id="DateTo"
                 class="form-control input-text-css"
                 required
                 #refDateTo="ngModel"
                 [ngClass]="{
              'is-invalid': df.submitted && refDateTo.invalid,
              'alert-warning':
                refDateTo.invalid &&
                (refDateTo.dirty || refDateTo.touched || refDateTo.untouched)
            }" />

          <mat-datepicker-toggle matSuffix
                                 [for]="picker2"></mat-datepicker-toggle>
          <mat-datepicker #picker2></mat-datepicker>
        </div>
      </div>

      <div class="col-md-2 p-1">
        <span class="required-lable">Select Status</span>
        <select name="SelectStatus"
                id="SelectStatus"
                #refSelectStatus="ngModel"
                class="form-control input-text-css"
                [(ngModel)]="SelectStatus">
          <option value="">All</option>
          <option value="PENDING">Pending</option>
          <option value="CALLED">Called</option>
          <option value="PROCESSED">Processed</option>
        </select>
      </div>
      <div class="col-md-2">
        <button type="button"
                (click)="searchQuickloanCustomerInquiry()"
                class="mt-3 btn font-size-12 button-btn"
                [disabled]="!df.form.valid">
          Search
        </button>
      </div>

      <div class="float-end col-md-4 mt-2" [hidden]="!dataSource">
        <form action="" class="search-text">
          <div class="bg-light rounded rounded-pill shadow-sm">
            <div class="input-group">
              <input type="text"
                     id="FilterInputSearch"
                     (keyup)="applyFilter($event.target.value)"
                     name="FilterInputSearch"
                     placeholder="What're you searching for?"
                     class="form-control border-0 bg-light" />
              <div class="input-group-append">
                <button id="button-addon1"
                        type="submit"
                        class="btn btn-link text-primary">
                  <i class="fa fa-search"></i>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </form>

  <div [hidden]="!dataSource" class="mt-3">
    <div class="table-responsive" style="overflow: auto; height: 65vh">
      <table mat-table
             [dataSource]="dataSource"
             class="mat-elevation-z8"
             matTableExporter
             #exporter="matTableExporter">
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef>#</th>
          <td mat-cell *matCellDef="let element; let i = index">
            {{ paginatorRef.pageIndex * paginatorRef.pageSize + i + 1 }}
          </td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Customer Name</th>
          <td mat-cell *matCellDef="let element">
            {{
              element.name
            }}
          </td>
        </ng-container>
        <ng-container matColumnDef="phoneNumber">
          <th mat-header-cell *matHeaderCellDef class="text-center">
            Phone Number
          </th>
          <td mat-cell *matCellDef="let element" class="text-center">
            {{ element.phoneNumber }}
          </td>
        </ng-container>
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef class="text-center">Status</th>
          <td mat-cell *matCellDef="let element" class="text-center">
            {{ element.status }}
          </td>
        </ng-container>
        <ng-container matColumnDef="employeeName">
          <th mat-header-cell *matHeaderCellDef class="text-center">Employee Name</th>
          <td mat-cell *matCellDef="let element" class="text-center">
            {{ element.employeeName }}
          </td>
        </ng-container>


        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef>
            email
          </th>
          <td mat-cell *matCellDef="let element">
            <span *ngIf="currentUser?.IsMaskingMobile">{{ element.email | emailmask }}</span><span *ngIf="!currentUser?.IsMaskingMobile">{{ element.email }}</span>
          </td>
        </ng-container>
        <ng-container matColumnDef="loanAmount">
          <th mat-header-cell *matHeaderCellDef>Required Loan Amount</th>
          <td mat-cell *matCellDef="let element" class="text-center">
            {{ element.loanAmount }}
          </td>
        </ng-container>

        <ng-container matColumnDef="createdAt">
          <th mat-header-cell *matHeaderCellDef>Request Date</th>
          <td mat-cell *matCellDef="let element">
            {{ element.createdAt | date : "dd-MM-yyyy hh:mm a" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="city">
          <th mat-header-cell *matHeaderCellDef>city</th>
          <td mat-cell *matCellDef="let element">
            {{ element.city }}
          </td>
        </ng-container>
        <ng-container matColumnDef="remarks">
          <th mat-header-cell *matHeaderCellDef class="text-center">Reason</th>
          <td mat-cell *matCellDef="let element" class="text-center">
            {{ element.remarks }}
          </td>
        </ng-container>

        <ng-container matColumnDef="Action">
          <th mat-header-cell class="grid-header j-c-center" *matHeaderCellDef>
            Action
          </th>
          <td mat-cell *matCellDef="let row" class="grid-cell text-center">
            <i *ngIf="row.status === 'PENDING'"
               class="fa fa-arrow-circle-right arrow-circle action-btn"
               aria-label="true"
               (click)="viewLoanDetail(row)"></i>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row
            [ngClass]="{
            pending: row.status == 'PENDING',
            Hold: row.status == 'CALLED',
            Completed: row.status == 'PROCESSED'
          }"
            *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  </div>

  <div class="row m-0 ml-3" [hidden]="!dataSource">
    <div class="col-md-4 mt-3">
      <button class="mt-2 btn font-size-12 button-btn"
              (click)="exportexcelNew()">
        <i class="fa fa-file-export mr-1"
           style="font-size: medium; cursor: pointer"></i>
        Export
      </button>
    </div>
    <div class="col-md-8 mt-2">
      <mat-paginator #paginatorRef
                     [pageSizeOptions]="[20, 50]"
                     showFirstLastButtons></mat-paginator>
    </div>
  </div>

  <div class="modal fade in"
       id="loanInNeedModal"
       tabindex="-1"
       role="dialog"
       aria-labelledby="myModalLabel"
       data-backdrop="false"
       style="background-color: rgba(0, 0, 0, 0.5); overflow: auto">
    <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
      <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-content">
        <div cdkDragHandle class="modal-header" style="padding: 0.625rem">
          <h6 class="modal-title" id="myModalLabel" name="myModalLabel">
            Customer Inquiry Details
          </h6>
          <button type="button"
                  (click)="onClose()"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close">
            <span aria-hidden="true">
              <i class="far text-black fa-times-circle"></i>
            </span>
          </button>
        </div>

        <form #rf="ngForm" novalidate>
          <div class="modal-body">
            <div class="formborder mt-2">
              <div class="row m-0 mt-2 col-md-12">
                <div class="col-md-12 bg-success1">
                  <h6 class="fs-14"> Demographic Information:</h6>
                </div>
              </div>

              <div class="row col-md-12 mt-2">
                <div class="col-md-3 mb-3">
                  <h6 class="fs-14">Customer Name</h6>
                  <span class="fs-12">
                    {{ rowData?.name}}
                  </span>
                </div>



                <div class="col-md-3 mb-3">
                  <h6 class="fs-14">Mobile No</h6>
                  <span class="fs-12">{{ rowData?.phoneNumber }}</span>
                </div>

                <div class="col-md-3 mb-3">
                  <h6 class="fs-14">Email Id</h6>
                  <span class="fs-12"><span *ngIf="currentUser?.IsMaskingMobile">{{ rowData?.email | emailmask }}</span><span *ngIf="!currentUser?.IsMaskingMobile">{{ rowData?.email }}</span></span>
                </div>



                <div class="col-md-3 mb-3">
                  <h6 class="fs-14">Loan Amount</h6>
                  <span class="fs-12">{{ rowData?.loanAmount }}</span>
                </div>


                <div class="col-md-3 mb-3">
                  <h6 class="fs-14">Applied Date</h6>
                  <span class="fs-12">{{ rowData?.createdAt| date : "dd-MM-yyyy hh:mm a"}}</span>
                </div>
                <div class="col-md-3 mb-3">
                  <h6 class="fs-14">City</h6>
                  <span class="fs-12">{{ rowData?.city }}</span>
                </div>

              </div>

              <div class="row col-md-12 mt-2">
                <!--<div class="col-md-3 mb-3">
                  <span class="required-lable">Select Status</span>
                  <select name="UpdateStatus"
                          id="UpdateStatus"
                          required
                          #refUpdateStatus="ngModel"
                          [ngClass]="{
                              'is-invalid': rf.submitted && refUpdateStatus.invalid,
                              'alert-warning':
                                refUpdateStatus.invalid &&
                                (refUpdateStatus.dirty ||
                                  refUpdateStatus.touched ||
                                  refUpdateStatus.untouched)
                            }"
                          class="form-control input-text-css"
                          [(ngModel)]="UpdateStatus">
                    <option value="">Select Status</option>
                    <option value="CALLED">Call Done</option>
                    <option value="PROCESSED">Processed</option>
                  </select>
                </div>-->
                <div class="col-md-10 mb-3">
                  <span class="required-lable">Remark</span>
                  <input type="text"
                         required
                         #refReason="ngModel"
                         [(ngModel)]="Reason"
                         placeholder="Reason"
                         name="Reason"
                         id="Reason"
                         class="form-control input-text-css"
                         [ngClass]="{
                         'is-invalid': rf.submitted && refReason.invalid,
                         'alert-warning':
                           refReason.invalid &&
                           (refReason.dirty ||
                             refReason.touched ||
                             refReason.untouched)
                       }" />
                </div>

                <div class="col-md-2 mt-3 text-center">
                  <button type="button"
                          [disabled]="!rf.form.valid"
                          (click)="UpdateStatusInquiry()"
                          class="btn font-size-12 button-btn">
                    Call Done
                  </button>
                </div>
              </div>

            </div>




          </div>
        </form>
      </div>
    </div>
  </div>


</div>

<table id="customer_lead"
       class="table table-bordered bg-white"
       style="font-family: 'Times New Roman', Times, serif; display: none">
  <tr>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">#</th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Customer Name
    </th>

    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Mobile No
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Loan Required
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Request Date
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Address
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Status
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Reason
    </th>
  </tr>

  <tr *ngFor="let element of JsonData; let i = index">
    <td>{{ i + 1 }}</td>
    <td>
      {{element.name  }}
    </td>
    <td>{{ element.phoneNumber }}</td>
    <td><span *ngIf="currentUser?.IsMaskingMobile">{{ element.email | emailmask }}</span><span *ngIf="!currentUser?.IsMaskingMobile">{{ element.email }}</span></td>
    <td>{{ element.loanAmount }}</td>
    <td>{{ element.city }}</td>
    <td>{{ element.status }}</td>
    <td>{{ element.createdAt | date : "dd-MM-yyyy hh:mm a"  }}</td>
    <td>{{ element.employeeName }}</td>
    <td>{{ element.remarks }}</td>
  </tr>
</table>
